module.exports = __webpack_public_path__ + "media/customizations/wilderranch/logo-c3035c863778bfcbc292a8a9c3685e2c.png";